// extracted by mini-css-extract-plugin
module.exports = {"content":"antd-pro-layouts-basic-layout-content"};